export default{
  'Voltammetry Discrete (VD)__RAW_GRAPH_BOOL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 12
  },
  'Voltammetry Discrete (VD)__Original Data': {
    'x': 0,
    'y': 12,
    'w': 16,
    'h': 12
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__HEATMAP_MAPPING_PLOT': {
    'x': 0,
    'y': 9,
    'w': 9,
    'h': 12
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__COLUMN_VAR_MAPPING_PLOT': {
    'x': 0,
    'y': 2,
    'w': 9,
    'h': 7
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__TABLE_GENERAL_STATISTICS': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 2
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__ROW_VAR_MAPPING_PLOT': {
    'x': 9,
    'y': 9,
    'w': 5,
    'h': 12
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__HISTOGRAM_MAPPING_PLOT': {
    'x': 9,
    'y': 2,
    'w': 7,
    'h': 7
  },
  'Fit peakPos - Voltammetry Discrete (VD)__HEATMAP_MAPPING_PLOT': {
    'x': 0,
    'y': 9,
    'w': 9,
    'h': 12
  },
  'Fit peakPos - Voltammetry Discrete (VD)__COLUMN_VAR_MAPPING_PLOT': {
    'x': 0,
    'y': 2,
    'w': 9,
    'h': 7
  },
  'Fit peakPos - Voltammetry Discrete (VD)__TABLE_GENERAL_STATISTICS': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 2
  },
  'Fit peakPos - Voltammetry Discrete (VD)__ROW_VAR_MAPPING_PLOT': {
    'x': 9,
    'y': 9,
    'w': 5,
    'h': 12
  },
  'Fit peakPos - Voltammetry Discrete (VD)__HISTOGRAM_MAPPING_PLOT': {
    'x': 9,
    'y': 2,
    'w': 7,
    'h': 7
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__HEATMAP_MAPPING_PLOT': {
    'x': 0,
    'y': 9,
    'w': 9,
    'h': 12
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__COLUMN_VAR_MAPPING_PLOT': {
    'x': 0,
    'y': 2,
    'w': 9,
    'h': 7
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__TABLE_GENERAL_STATISTICS': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 2
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__ROW_VAR_MAPPING_PLOT': {
    'x': 9,
    'y': 9,
    'w': 5,
    'h': 12
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__HISTOGRAM_MAPPING_PLOT': {
    'x': 9,
    'y': 2,
    'w': 7,
    'h': 7
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Fit peakHeight - Voltammetry Discrete (VD)__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 16,
    'h': 11
  },
  'Fit peakPos - Voltammetry Discrete (VD)__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Fit peakPos - Voltammetry Discrete (VD)__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 16,
    'h': 12
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Fit peakAUC - Voltammetry Discrete (VD)__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 16,
    'h': 12
  },
  'Impedance Discrete (ID) Magnitude__RAW_GRAPH_BOOL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 12
  },
  'Impedance Discrete (ID) Phase__RAW_GRAPH_BOOL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 12
  },
  'Impedance Discrete (ID) Complex__RAW_GRAPH_BOOL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 12
  },
  'Circuit Draw__CIRCUIT_DRAW_IMPEDANCE': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 12
  },
  'Fit Ȳ - Impedance Discrete (ID) Magnitude__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 2
  },
  'Fit Ȳ - Impedance Discrete (ID) Magnitude__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 2,
    'w': 16,
    'h': 12
  },
  'Fit Ȳ - Impedance Discrete (ID) Phase__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Fit Ȳ - Impedance Discrete (ID) Phase__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 16,
    'h': 12
  },
  'Potentiometry Continuous (PC)__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Potentiometry Continuous (PC)__RAW_GRAPH_BOOL': {
    'x': 8,
    'y': 3,
    'w': 8,
    'h': 12
  },
  'Potentiometry Continuous (PC)__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 8,
    'h': 12
  },
  'Potentiometry Continuous (PC)__Original Data': {
    'x': 0,
    'y': 15,
    'w': 8,
    'h': 12
  },
  'Potentiometry Continuous (PC) - Extracted Values__SENSOR_EXTRACTED_TABLE':{
    'x': 0,
    'y': 0,
    'w': 16
  },
  'Amperometry Continuous (AC)__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Amperometry Continuous (AC)__RAW_GRAPH_BOOL': {
    'x': 8,
    'y': 3,
    'w': 8,
    'h': 12
  },
  'Amperometry Continuous (AC)__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 8,
    'h': 12
  },
  'Amperometry Continuous (AC)__Original Data': {
    'x': 0,
    'y': 15,
    'w': 8,
    'h': 12
  },
  'Amperometry Continuous (AC) - Extracted Values__SENSOR_EXTRACTED_TABLE':{
    'x': 0,
    'y': 0,
    'w': 16
  },
  'Continuous__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 3
  },
  'Continuous__RAW_GRAPH_BOOL': {
    'x': 8,
    'y': 3,
    'w': 8,
    'h': 12
  },
  'Continuous__FIT_STEP_GRAPH_BOOL': {
    'x': 0,
    'y': 3,
    'w': 8,
    'h': 12
  },
  'Continuous__Original Data': {
    'x': 0,
    'y': 15,
    'w': 8,
    'h': 12
  },
  'Statistical Evaluation Step Fit__TABLE_STATS_EVAL': {
    'x': 0,
    'y': 24,
    'w': 16
  },
  'Statistical Evaluation Step Fit__BATCH_HIST': {
    'x': 0,
    'y': 12,
    'w': 16,
    'h': 12
  },
  'Statistical Evaluation Step Fit__BATCH_SCATTER': {
    'x': 0,
    'y': 0,
    'w': 8,
    'h': 12
  },
  'Statistical Evaluation Step Fit__BATCH_BOX': {
    'x': 8,
    'y': 0,
    'w': 8,
    'h': 12
  },
  'Independent Statistical Evaluation__SEN_IND_TABLE': {
    'x': 0,
    'y': 0,
    'w': 16,
  },
  'Independent Statistical Evaluation__SEN_PRED_IND_TABLE': {
    'x': 0,
    'y': 10,
    'w': 16,
  },
  'Independent Statistical Evaluation__PRED_IND_TABLE': {
    'x': 0,
    'y': 20,
    'w': 16,
  },
  'Report comparison__GRAPHS_FIT': {
    'x': 0,
    'y': 0,
    'w': 16,
    'h': 12
  },
  'Report comparison__COEFFICIENTS_INFO': {
    'x': 0,
    'y': 10,
    'w': 16,
  },
  'Report comparison__B_PREDICTED_VALS': {
    'x': 0,
    'y': 20,
    'w': 16,
  }
}